
import { useQueryClient } from '@tanstack/react-query';
import { useToast } from '@/hooks/use-toast';
import { useUpdateRoyaltyReport } from '@/hooks/useRoyaltyReports';
import { FormData } from './formSchema';

export const useFormSubmit = (onSuccess?: () => void) => {
  const { toast } = useToast();
  const updateReport = useUpdateRoyaltyReport();
  const queryClient = useQueryClient();

  const onSubmit = async (data: FormData) => {
    try {
      for (const bookData of data.books) {
        if (bookData.reportId) {
          const reportData = {
            year: data.year,
            quarter: data.quarter,
            bookId: bookData.bookId,
            country: bookData.country,
            salesCount: bookData.unitsSold,
            amount: bookData.royaltyAmount,
            status: data.status,
            currency: 'USD',
            unitsSold: bookData.unitsSold,
            grossSales: bookData.grossSales,
            netSales: bookData.netSales, // Use the actual netSales value (Previous Royalty Income)
            royaltyAmount: bookData.royaltyAmount,
            bookFormat: bookData.bookFormat,
          };
          
          await updateReport.mutateAsync({
            reportId: bookData.reportId,
            reportData
          });
        }
      }
      
      queryClient.invalidateQueries({ queryKey: ['royaltyReports'] });
      queryClient.invalidateQueries({ queryKey: ['royaltyReport'] });
      queryClient.invalidateQueries({ queryKey: ['quarterlyReports'] });
      
      toast({
        title: 'Success',
        description: 'Royalty reports have been updated successfully.',
      });
      
      if (onSuccess) {
        onSuccess();
      }
    } catch (error) {
      console.error('Error updating royalty reports:', error);
      toast({
        title: 'Error',
        description: 'Failed to update royalty reports. Please try again.',
        variant: 'destructive',
      });
    }
  };

  return { onSubmit, updateReport };
};
